import React from "react";
import { FieldFormV2, FieldV2, LoadingV2 } from "@ucl/library";
import { useUnderwritingRuleResultForm } from "@/hooks/useUnderwritingRuleResultForm";
import { FIELD_KEYS } from "@/constants";
import { UnderwritingRuleResultUpdateDTO } from "@/types/UnderwritingRuleResultUpdateDTO";

export interface UnderwritingRuleResultFormProps {
  ruleResultId: string;
}

export const UnderwritingRuleResultForm: React.FC<UnderwritingRuleResultFormProps> = ({
  ruleResultId,
}) => {
  const {
    formValue,
    setFormValue,
    saveFormData,
    schemaFactory,
    formBuilder,
    fieldFormModule,
    loading,
    error,
  } = useUnderwritingRuleResultForm(ruleResultId);

  if (loading) {
    return <LoadingV2 />;
  }

  if (error) {
    return (
      <div style={{ color: "red", padding: "10px" }}>
        Error: {error}
      </div>
    );
  }

  if (!schemaFactory || !formBuilder || !formValue) {
    return <LoadingV2 />;
  }

  return (
    <FieldFormV2<UnderwritingRuleResultUpdateDTO>
      ref={fieldFormModule}
      value={formValue}
      fieldSchemaFormBuilder={formBuilder}
      onFormSubmit={async (value) => {
        await saveFormData(value);
      }}
      onFieldChanged={(newValue, newFieldValue, _fieldProps) => {
        setFormValue(newValue, newFieldValue);
      }}
      errors={{}}
    >
      <FieldV2
        fieldProps={{
          fieldKey: FIELD_KEYS.UNDERWRITING_RULE_RESULT.RESULT_TYPE,
        }}
      />
      <FieldV2
        fieldProps={{
          fieldKey: FIELD_KEYS.UNDERWRITING_RULE_RESULT.RESULT_COMMENT,
        }}
      />
    </FieldFormV2>
  );
};
